import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

export class NotebookSections extends React.Component {
  render() {
    return <div className='notebook-sections'>{this.props.children}</div>;
  }
}
NotebookSections.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};
